import React from 'react'
import { MarkdownPage } from '@/shared/components'
import AppFooter from '@/shared/components/AppFooter'

export const PrivacyPolicyPage: React.FC = () => {
  return (
    <>
      <MarkdownPage fileUrl="/docs/privacy-policy.md" />
      <AppFooter />
    </>
  )
}
